const RESET_EMAIL_BLURRED = 'RESET_EMAIL_BLURRED';
const RESET_EMAIL_FOCUSED = 'RESET_EMAIL_FOCUSED';
const RESET_EMAIL_SET = 'RESET_EMAIL_SET';
const RESET_EMAIL_CHANGE = 'RESET_EMAIL_CHANGE';
const RESET_EMAIL_SET_FOCUS = 'RESET_EMAIL_SET_FOCUS';
const RESET_EMAIL_SET_VALIDATION_MESSAGE = 'RESET_EMAIL_SET_VALIDATION_MESSAGE';
const RESET_EMAIL_SET_API_ERROR = 'RESET_EMAIL_SET_API_ERROR';
const RESET_EMAIL_SET_VISUALIZATION = 'RESET_EMAIL_SET_VISUALIZATION';

const resetEmailSet = (email) => ({
  type: RESET_EMAIL_SET,
  payload: email
});

const resetEmailSetFocus = (focused) => ({
  type: RESET_EMAIL_SET_FOCUS,
  payload: focused
});

const resetEmailSetValidationMessage = (validationMessage) => ({
  type: RESET_EMAIL_SET_VALIDATION_MESSAGE,
  payload: validationMessage
});

const resetEmailSetVisualization = (visualized) => ({
  type: RESET_EMAIL_SET_VISUALIZATION,
  payload: visualized
});

const resetEmailBlur = (markedAsWrong, validationMessage) => ({
  type: RESET_EMAIL_BLURRED,
  payload: { markedAsWrong, validationMessage }
});

const resetEmailFocus = () => ({
  type: RESET_EMAIL_FOCUSED
});

const resetEmailChange = (payload) => ({
  type: RESET_EMAIL_CHANGE,
  payload
});

const resetEmailSetApiError = (errors) => ({
  type: RESET_EMAIL_SET_API_ERROR,
  payload: errors
});


export {
  RESET_EMAIL_SET,
  RESET_EMAIL_CHANGE,
  RESET_EMAIL_SET_VALIDATION_MESSAGE,
  RESET_EMAIL_SET_VISUALIZATION,
  RESET_EMAIL_SET_FOCUS,
  RESET_EMAIL_BLURRED,
  RESET_EMAIL_FOCUSED,
  RESET_EMAIL_SET_API_ERROR,
  resetEmailSetApiError,
  resetEmailBlur,
  resetEmailFocus,
  resetEmailSet,
  resetEmailChange,
  resetEmailSetVisualization,
  resetEmailSetValidationMessage,
  resetEmailSetFocus
};
